import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { CompanyBankDetailsStoreType } from "modules/dictionaries/bank-details/models/bank-details-store";
import { ProjectPortfoliosStoreType } from "modules/dictionaries/project-portfolios/models/project-portfolio-store";
import dictionaries from "modules/dictionaries/functionalities";
import { MaterialValuesStoreType } from "modules/dictionaries/inventory/models/material-value-store";
import { can, canAny } from "modules/session/auth/access";
import { SessionType } from "modules/session/auth/models/session";
import func from "modules/spending/functionalities";
import React from "react";
import { RouteObject } from "react-router-dom";
import SpendingTabsPage from "./components/SpendingTabsPage";
import { DepartmentsPage } from "./departments/components/DepartmentsPage";
import EmployeePage from "./employee/components/EmployeePage";
import { EmployeeStoreType } from "./employee/models/employee-store";
import { OneCStoreType } from "./onec/models/onec-store";
import { OrganisationsPage } from "./organisations/components/OrganisationsPage";
import { SchedulePage } from "./schedule/components/SchedulePage";
import { ScheduleStoreType } from "./schedule/models/schedule-store";
import { TimesheetPage } from "./timesheet/components/TimesheetPage";
import { TimesheetStoreType } from "./timesheet/models/timesheet-store";
import { UnitPage } from "./unit/components/UnitPage";
import { UnitStoreType } from "./unit/models/unit-store";
import { WorkloadPlanStoreType } from "./workload-plan/models/plan-store";

export const buildRoutes = ({
  loggedIn,
  timesheet,
  session,
  schedule,
  unit,
  employee,
  workloadPlan,
  materials,
  onec,
  bankDetails,
  portfolios,
}: RoutesProps): RouteObject[] => {
  const setUserFilter = (value: string) => {
    timesheet.setQuery(value);
    workloadPlan.setQuery(value);
    unit.setQuery(value);
    schedule.setQuery(value);
  };

  return [
    {
      path: `${routes.spending.path}/*`,
      element: (
        <ProtectedRoute loggedIn={loggedIn}>
          <SpendingTabsPage
            organisationsPanel={
              can(dictionaries.BANKDETAILS_READ, session.access) ? (
                <OrganisationsPage store={portfolios} bankDetails={bankDetails} access={session.access} />
              ) : null
            }
            timesheetPanel={
              canAny([func.TIMESHEET_EDIT, func.TIMESHEET_EDIT_DEPARTMENT, func.TIMESHEET_EDIT_USER], session.access) ? (
                <TimesheetPage store={timesheet} schedule={schedule} session={session} setUserFilter={setUserFilter} />
              ) : null
            }
            unitPanel={
              can(func.WORKOUT_UNIT, session.access) ? <UnitPage store={unit} setUserFilter={setUserFilter} /> : null
            }
            schedulePanel={
              can(func.SCHEDULE_READ, session.access) ? (
                <SchedulePage store={schedule} timesheet={timesheet} session={session} setUserFilter={setUserFilter} />
              ) : null
            }
            departmentsPanel={
              can(func.DEPARTMENT_READ, session.access) ? (
                <DepartmentsPage access={session.access} baseUrl={session.baseUrl} />
              ) : null
            }
            employeePanel={
              can(func.EMPLOYER_READ, session.access) ? (
                <EmployeePage
                  baseUrl={session.baseUrl}
                  store={employee}
                  access={session.access}
                  materials={materials}
                  session={session}
                  onec={onec}
                />
              ) : null
            }
          />
        </ProtectedRoute>
      ),
    },
  ];
};

interface RoutesProps extends LoggedInProps {
  schedule: ScheduleStoreType;
  timesheet: TimesheetStoreType;
  workloadPlan: WorkloadPlanStoreType;
  unit: UnitStoreType;
  session: SessionType;
  employee: EmployeeStoreType;
  materials: MaterialValuesStoreType;
  onec: OneCStoreType;
  bankDetails: CompanyBankDetailsStoreType;
  portfolios: ProjectPortfoliosStoreType;
}
